import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

interface ClearCheckpointProps {
  /** Label shown in the dialog title and trigger button */
  checkpointDescription: string;
  /** Called when the user confirms clearing the checkpoint */
  onClear: () => void;
  /** Label text for the inline trigger button */
  buttonLabel: string;
  /** Optional icon rendered before the button text */
  icon?: React.ReactNode;
  /** Button variant (default: "contained") */
  variant?: "contained" | "outlined" | "text";
  /** Button color (default: "secondary") */
  color?: "primary" | "secondary" | "error" | "inherit";
  size?: "small";
  /** Optional inline styles applied to the button */
  buttonStyle?: React.CSSProperties;
}

export const ClearCheckpoint = ({
  checkpointDescription,
  onClear,
  buttonLabel,
  variant = "contained",
  color = "secondary",
  size = "small",
  buttonStyle,
}: ClearCheckpointProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Box onClick={() => setOpen(true)} sx={{ cursor: "pointer" }}>
        <Button
          variant={variant}
          color={color}
          size={size}
          style={{ ...buttonStyle }}
        >
          <CheckIcon style={{ marginRight: 6, fontSize: 16 }} />
          {buttonLabel}
        </Button>
      </Box>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="clear-checkpoint-dialog-title"
        aria-describedby="clear-checkpoint-dialog-desc"
      >
        <DialogTitle id="clear-checkpoint-dialog-title">
          Clear Checkpoint {checkpointDescription}?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="clear-checkpoint-dialog-desc">
            Are you sure you want to clear this checkpoint and proceed with the
            automation?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button
            onClick={() => {
              onClear();
              setOpen(false);
            }}
            color="error"
            autoFocus
          >
            Clear
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
